<template>
  <div
    id="app"
  
    
  >
   
    <router-view />
   
  </div>
</template>

<script>
export default {
  name: "App",
 
};
</script>

<style lang='less'>
@import "~assets/css/color.less";
</style>
<style>
@import "~assets/css/font-awesome.min.css";
</style>

 